import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import {
  getCustomerConfirmDetailsAction,
  getCustomerLeadDetailsAction,
  getCustomerLeadsAction,
  getCustomerQuoteDetailsAction,
  getCustomerSurveyDetailsAction,
  getQuotationAction,
  setCustomerConfirmDetailsAction,
  setCustomerLeadDetailsAction,
  setCustomerLeadsAction,
  setCustomerQuoteDetailsAction,
  setCustomerSurveyDetailsAction,
  setQuotationAction,
  setUpdateQuatationAction,
  updateQuatationAction,
  requestSurveyAction,
  updateCustomerQuote,
  getCustomerMergeListAction,
  setCustomerMergeListAction,
  updateCustomerMergeAction,
  setCustomerMergeResponseAction,
  getCustomerSettingResponseAction,
  setCustomerSettingResponseAction,
  updateCustomerSettingAction,
  setUpdateCustomerSettingAction,
  customerResendCustomerLike,
  setCustomerResendCustomerResponse,
  requestStartSurveyAction,
  setRequestStartSurveyAction,
  getQuoteConfirmDetailsAction,
  setQuoteConfirmDetailsAction,
  updateQuoteConfirmAction,
  setUpdateQuoteConfirmAction,
} from "../reducers/customerSlice";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { getSingleLeadAction } from "../reducers/leadSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getQuotationSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `customers/confirmation`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setQuotationAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateQuatationSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `customers/confirmation`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateQuatationAction(true));
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setUpdateQuatationAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerLeadsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(callAPI, {}, "get", `customers/leads`);
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerLeadsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerLeadDetailsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, query } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `customers/leads/${leadId}?query=${query}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerLeadDetailsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerSurveyDetailsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { surveyID, query } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `customers/surveys/${surveyID}?query=${query}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerSurveyDetailsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerQuoteDetailsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, query } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `customers/leads/${leadId}?query=${query}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerQuoteDetailsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerConfirmDetailsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, query } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `customers/leads/${leadId}?query=${query}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerConfirmDetailsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* requestStartSurveySaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {
        payload: {
          query: "start-survey",
        },
      },
      "post",
      `customers/leads/${leadId}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(
        getCustomerLeadDetailsAction({
          leadId: leadId,
          query: "get-lead",
        }),
      );
      yield put(setRequestStartSurveyAction(true));
      yield put(getCustomerLeadsAction());
      yield put(getSingleLeadAction({ generateId: leadId, role: "customer" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* requestSurveySaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {
        payload: {
          query: "request-survey",
        },
      },
      "post",
      `customers/leads/${leadId}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateCustomerQuoteSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `customers/quote`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateQuatationAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setUpdateQuatationAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerMergeListSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { pagination = { currentPage: 1 }, matchBy = "" } =
      action.payload || {};
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/customer-merge?matchBy=${matchBy}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerMergeListAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateCustomerMergeSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/customer-merge`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCustomerMergeResponseAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setCustomerMergeResponseAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerResponseSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { pagination = { currentPage: 1 }, matchBy = "" } =
      action.payload || {};
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/settings/customers`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCustomerSettingResponseAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateCustomerSettingSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/settings/customers`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateCustomerSettingAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setUpdateCustomerSettingAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* customerResendCustomerLikSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `leads/customers/resend-link`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCustomerResendCustomerResponse(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setCustomerResendCustomerResponse(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

// quote confirm details
function* getQuoteConfirmDetailsSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, query } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `/customers/quote-with-confirmation?leadId=${leadId}`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setQuoteConfirmDetailsAction(apiResponse?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

// quote confirm update
function* updateQuoteConfirmSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `customers/quote-with-confirmation`,
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateQuoteConfirmAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response);
    yield put(setUpdateQuoteConfirmAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

export function* watchCustomer() {
  yield takeLatest<any>(getQuotationAction, getQuotationSaga);
  yield takeLatest<any>(updateQuatationAction, updateQuatationSaga);
  yield takeLatest<any>(getCustomerLeadsAction, getCustomerLeadsSaga);
  yield takeLatest<any>(
    getCustomerLeadDetailsAction,
    getCustomerLeadDetailsSaga,
  );
  yield takeLatest<any>(
    getCustomerSurveyDetailsAction,
    getCustomerSurveyDetailsSaga,
  );
  yield takeLatest<any>(
    getCustomerQuoteDetailsAction,
    getCustomerQuoteDetailsSaga,
  );
  yield takeLatest<any>(requestSurveyAction, requestSurveySaga);
  yield takeLatest<any>(requestStartSurveyAction, requestStartSurveySaga);
  yield takeLatest<any>(
    getCustomerConfirmDetailsAction,
    getCustomerConfirmDetailsSaga,
  );
  yield takeLatest<any>(updateCustomerQuote, updateCustomerQuoteSaga);
  yield takeLatest<any>(getCustomerMergeListAction, getCustomerMergeListSaga);
  yield takeLatest<any>(updateCustomerMergeAction, updateCustomerMergeSaga);
  yield takeLatest<any>(
    getCustomerSettingResponseAction,
    getCustomerResponseSaga,
  );
  yield takeLatest<any>(updateCustomerSettingAction, updateCustomerSettingSaga);
  yield takeLatest<any>(
    customerResendCustomerLike,
    customerResendCustomerLikSaga,
  );
  yield takeLatest<any>(getQuoteConfirmDetailsAction, getQuoteConfirmDetailsSaga);
  yield takeLatest<any>(updateQuoteConfirmAction,updateQuoteConfirmSaga);
}
